import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Publish from '../publish/Publish';
import Author from '../author/Author';
import {Layout, Skeleton, Result, Button} from 'antd';
import { appEngineConfig, dmsConfig } from '../../../config/env';
import { fetchViewerType } from '../../../actions/settings.actions';

import firebase from 'firebase';

const { Header, Content, Footer } = Layout;

const Main = props => {
    const { fetchViewerType } = props;
    const [isLogged, setIsLogged] = useState(false);
    const [viewerType, setViewerType] = useState();
    const [userEmail, setUserEmail] = useState(null);

    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            setIsLogged(true);
            setUserEmail(user.email);
        } else {
            let provider = new firebase.auth.GoogleAuthProvider();
            provider.setCustomParameters({ hd: 'barry-callebaut.com' });
            firebase.auth().signInWithRedirect(provider);
        }
    });

    /** When: user logged in **/
    useEffect(() => {
        fetchViewerType();
    }, [isLogged, fetchViewerType]);

    useEffect(() => {
        if (isLogged && userEmail !== null) {
            fetch(appEngineConfig.url + '/admin', {
                method: 'POST',
                headers: {
                    'access-control-allow-origin': '*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email: userEmail })
            })
                .then(res => res.json())
                .then(resData => {})
                .catch(err => []);
        }
    }, [userEmail, isLogged]);

    /** When: viewer type fetched **/
    useEffect(() => {
        setViewerType(props.viewerType);
    }, [props.viewerType, setViewerType]);

    if (isLogged) {
        if (viewerType === 'publish') {
            return (
                <React.Fragment>
                    <Publish />
                    <iframe src={dmsConfig.authTrigger} style={{ display: 'none' }} title="dms authentication trigger" />
                </React.Fragment>
            );
        } else if (viewerType === 'author') {
            return (
                <React.Fragment>
                    <Author />
                    <iframe src={dmsConfig.authTrigger} style={{ display: 'none' }} title="dms authentication trigger" />
                </React.Fragment>
            );
        } else if (viewerType === 'permission-denied') {
            return (
                <Wrapper>
                    <Result
                        status="403"
                        title="403"
                        subTitle="Sorry, you're not authorised to view this site."
                        extra={
                            <Button
                                onClick={o => {
                                    var auth2 = firebase.auth();
                                    auth2.signOut();
                                    auth2.disconnect();
                                }}
                                type="primary">
                                Sign in
                            </Button>
                        }
                    />
                </Wrapper>
            );
        }
    }
    return (
        <Wrapper>
            <Skeleton paragraph={{ rows: 25 }} active />
        </Wrapper>
    );
};

const mapStateToProps = state => ({
    viewerType: state.settings.viewerType
});
const mapDispatchToProps = {
    fetchViewerType
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Main);

const Wrapper = props => {
    return (
        <Layout className="layout">
            <Header theme="dark" className="header">
                <div className="logo">
                    <img src="https://upload.wikimedia.org/wikipedia/fr/7/74/Logo_Barry_Callebaut.svg" width="200" alt="Barry callebaut logo" />
                </div>
            </Header>
            <Content className="content" style={{marginTop: '64px', paddingTop:'2rem' }}>
                {props.children}
            </Content>
            <Footer>&copy; Barry Callebaut</Footer>
        </Layout>
    );
};
